/** Large on-screen numeric keypad for PIN entry (shared phone, gloves-friendly). */
export default function NumericKeypad(props: {
  value: string;
  onChange: (v: string) => void;
  maxLength?: number;
  onSubmit?: () => void;
}) {
  const { value, onChange, maxLength = 8, onSubmit } = props;
  const press = (d: string) => {
    if (value.length < maxLength) onChange(value + d);
  };
  return (
    <div className="keypad">
      <div className="pinDots">
        {Array.from({ length: Math.max(4, value.length) }).map((_, i) => (
          <span key={i} className={i < value.length ? 'pd filled' : 'pd'} />
        ))}
      </div>
      <div className="keys">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
          <button key={d} type="button" className="key" onClick={() => press(d)}>{d}</button>
        ))}
        <button type="button" className="key ghost" onClick={() => onChange('')}>Clear</button>
        <button type="button" className="key" onClick={() => press('0')}>0</button>
        <button type="button" className="key ghost" onClick={() => onChange(value.slice(0, -1))}>⌫</button>
      </div>
      {onSubmit && (
        <button type="button" onClick={onSubmit} disabled={value.length < 4}>Sign in</button>
      )}
    </div>
  );
}
